import { put, takeLatest } from 'redux-saga/effects';

import { requestCountryList } from '../../../services/country';
import { fetchCountryListFailure, fetchCountryListRequest, fetchCountryListSuccess } from '../../reducers/country';

export function* watchCountrySaga() {
  yield takeLatest(fetchCountryListRequest, fetchCountryList);
}

/**
 *
 * @param {*} param0
 */
function* fetchCountryList({ payload }) {
  try {
    const response = yield requestCountryList(payload);
    yield put(fetchCountryListSuccess(response));
  } catch (error) {
    yield put(fetchCountryListFailure('Failed to get list of Leads'));
  }
}
